import * as monacoEditor from 'monaco-editor/esm/vs/editor/editor.api';

// This registers somewhat naive highlighting for query plans.
export const registerQueryPlanLanguage = () => {
  monacoEditor.languages.register({
    id: 'queryPlan',
  });

  monacoEditor.languages.setMonarchTokensProvider('queryPlan', {
    tokenizer: {
      root: [
        [/[{},]/, 'punctuation'],
        [/\(/, 'punctuation', 'arguments'],
        [/QueryPlan|Sequence|Parallel|Flatten/, 'keyword'],
        [/Fetch/, 'keyword', 'preFetch'],
      ],
      preFetch: [
        // Use `switchTo` so that we don't add an extra `fetch` to the stack,
        // if we had an extra '{' we would need to pop twice to close the fetch
        [/{/, { token: 'punctuation', switchTo: 'fetch' }],
        [/\(/, 'punctuation', 'arguments'],
      ],
      fetch: [
        // Push / pop the {} stack to know when the fetch block is complete
        [/{/, 'punctuation', '@push'],
        [/}/, 'punctuation', '@pop'],
        [/=>/, 'punctuation'],
        [/\(/, 'punctuation', 'arguments'],
        [/\.\.\./, 'punctuation', 'fragmentOn'],
        [/[_a-zA-Z]\w*/, 'property'],
      ],
      arguments: [
        // Push / pop the () stack to know when the argument block is complete
        [/\(/, 'punctuation', '@push'],
        [/\)/, 'punctuation', '@pop'],
        [/[:{}\[\],]/, 'punctuation'],
        [/\$[_a-zA-Z]\w*/, 'variable'],
        [/"([^"]|\\")*"/, 'string'],
        [/true|false/, 'builtin.booleanvalue'],
        [/[0-9]+/, 'number'],
        [/[_a-zA-Z]\w*/, 'property'],
      ],
      fragmentOn: [
        [/on/, 'keyword'],
        [/[_a-zA-Z]\w*/, 'atom.namedtype', '@pop'],
      ],
    },
  });
};
